// ...existing code...
export const getFlagDisplay = flag => {
    if (flag === 'S') return { label: 'Sí', className: 'color-CC' };
    if (flag === 'N') return { label: 'No', className: 'color-AA' };
    return { label: 'No', className: 'color-AA' };
};